import { initializeApp, getApp, getApps } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  signInWithPhoneNumber,
  signInWithCustomToken,
  signOut,
  RecaptchaVerifier,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
} from "firebase/firestore";
import api, { setAuthToken } from "../../utils/api";
import config from "../../utils/config";

class Firebase {
  constructor() {
    if (getApps().length === 0) {
      initializeApp(config.firebase);
    }

    const app = getApp();
    this.auth = getAuth(app);
    this.db = getFirestore(app);
  }

  db = () => this.db;

  getTeamRef = (subdomain) => doc(collection(this.db, "teams"), subdomain);

  doSignInWithPhone = (number, verifier) => {
    return signInWithPhoneNumber(this.auth, number, verifier);
  };

  doSignInWithToken = (token) => {
    return signInWithCustomToken(this.auth, token);
  };

  doSignOut = () => {
    return signOut(this.auth);
  };

  getCurrentUserToken = (forceRefresh) => {
    if (!this.auth.currentUser) {
      return null;
    }
    return this.auth.currentUser.getIdToken(forceRefresh);
  };

  buildRecaptcha = (containerId) => {
    return new RecaptchaVerifier(this.auth, containerId, { size: "invisible" });
  };

  onAuthStateChanged = (callback) => onAuthStateChanged(this.auth, callback);

  onAuthUserListener = (next, fallback) =>
    onAuthStateChanged(this.auth, async (authUser) => {
      if (authUser) {
        try {
          const token = await authUser.getIdToken();
          setAuthToken(token);
          const response = await api.get("/userSearch");
          authUser = { whitelisted: true, ...response.data.user, token };
          next(authUser);
        } catch (e) {
          if (e.response && (e.response.status === 401 || e.response.status === 403)) {
            authUser = { whitelisted: false };
            next(authUser);
          } else {
            fallback();
          }
        }
      } else {
        fallback();
      }
    });
}
export default Firebase;
